import styles from "./MeetingControls.module.css";
import PropTypes from "prop-types";

import Toggler from "ManagementTeam/Shared/Toggler";
import Checkbox from "ManagementTeam/Shared/Checkbox";
import { nanoid } from "nanoid";
import Auth from "shared/@auth";
import { OptionsDropdown } from "../../OptionsDropdown/OptionsDropdown";
import { useEffect, useState } from "react";
import ObjectSelect from "ManagementTeam/Shared/ObjectSelect";

/**
 *  When the user presses the toggle button under Check In to On, the Check In functionality opens on the Diamond view. As Management Team members check in via the external app, a count displays for the current quorum total. Once the quorum is met based on Check In attendance, a green check mark displays. 
Please note: Even if a user checks out of a meeting, the quorum will still maintain the original checked in number. 
Auto Check will automatically allow Management Team members to check in 15 minutes prior to the start of the meeting. This feature is defaulted to ON. 
End session, when a meeting is part of a two day meeting, on the first day, the option is to “End Session”. When toggled ON, the toggle displays as red and ends the first day session for all users, including all voting items. This triggers Agendas and Decisions to be moved to the Archived sections of their respective page. Users are required to check in to the second session of a two day meeting, just like they did for the first day. 
End meeting, when toggled ON, the toggle displays as red and ends the meeting for all users, including all voting items. This triggers Agendas and Decisions to be moved to the Archived sections of their respective page 
 * 
 */

export function MeetingControls({
  dates,
  meetingType,
  currentQuorum,
  quorumTotal,
  autoCheckInMinutes,

  checkedIn,
  endSession,
  autoCheckIn,

  setCheckedIn,
  setEndSession,
  setAutoCheckIn,
  setAutoCheckInMinutes,
}) {
  const { hasPermission } = Auth.useContainer();
  const id = nanoid();
  const [endedOption, setEndedOption] = useState();
  const quorumValue = ["EC"].includes(meetingType)
    ? "N/A"
    : `${currentQuorum}/${quorumTotal}`;
  const [endedOptions, setEndedOptions] = useState();
  useEffect(() => {
    let _endedOptions = [
      { id: 1, option: "End Session" },
      { id: 2, option: "End Meeting" },
    ];
    if (dates.length === 2) {
      if (dates[0].sessionEnded) {
        _endedOptions.shift();
      }
    } else if (dates.length === 1) {
      _endedOptions.shift();
    }
    setEndedOptions(_endedOptions);
    setEndedOption(_endedOptions[0]);
  }, [dates]);
  return (
    <div className={styles.container}>
      <div className={styles.leftVerticalLine} />

      <div className={styles.grid}>
        <div className={styles.gridItem}>
          <div className={styles.gridItemTitle}>Check In</div>
          <Toggler
            visible={hasPermission("management-team.admins")}
            onChange={() => setCheckedIn(!checkedIn)}
            toggled={checkedIn}
            color={checkedIn ? "#39B54A" : "#D3D3D3"}
            key={id}
            disabled={autoCheckIn}
          />
        </div>

        <div className={styles.verticalLine} />

        <div className={styles.gridItem}>
          <div className={styles.gridItemTitle}>
            <div>Quorum</div>
            <div className={styles.q}>{quorumValue}</div>
          </div>
        </div>

        <div className={styles.verticalLine} />

        <div className={styles.gridItem}>
          <div className={styles.gridItemTitle}>
            {endedOption && (
              <ObjectSelect
                options={endedOptions}
                onChange={(e) => {
                  setEndedOption(
                    endedOptions.find((option) => option.id === e)
                  );
                }}
                placeholder={endedOption.option}
                selectedOption={endedOption}
                isDateOption={true}
              />
            )}
          </div>
          <Toggler
            visible={hasPermission("management-team.admins")}
            onChange={() => {
              const indexEnded = dates.findIndex((date) => date.sessionEnded);
              setEndSession(endedOption.id === 2, indexEnded + 1);
            }}
            toggled={endSession}
            color={endSession ? "#ED1F24" : "#D3D3D3"}
            key={id}
          />
        </div>
      </div>

      <div className={styles.horizontalLine} />
      {/* Uncomment when using auto check in */}
      {/* <div className={styles.checkboxContainer}>
        {autoCheckIn ? (
          <>
            <div>
              <Checkbox
                visible={hasPermission("management-team.admins")}
                checked={true}
                onChange={() => setAutoCheckIn()}
                className={styles.checkbox}
              />
              <span>Auto Check In</span>
            </div>
            <div className={styles.input}>
              Check In{" "}
              <input
                type="text"
                value={autoCheckInMinutes}
                onChange={(e) =>
                  setAutoCheckInMinutes(
                    isNaN(e.target.value) ? 0 : e.target.value
                  )
                }
              />{" "}
              Minutes before start time
            </div>
          </>
        ) : (
          <>
            <div>
              <Checkbox
                visible={hasPermission("management-team.admins")}
                checked={false}
                onChange={() => setAutoCheckIn()}
                className={styles.checkbox}
              />
              <span>Auto Check In</span>
            </div>
          </>
        )}
      </div> */}
    </div>
  );
}

MeetingControls.propTypes = {
  currentQuorum: PropTypes.number,
  quorumTotal: PropTypes.number,
  autoCheckInMinutes: PropTypes.number,

  checkedIn: PropTypes.bool,
  endSession: PropTypes.bool,
  autoCheckIn: PropTypes.bool,

  setCheckedIn: PropTypes.func,
  setEndSession: PropTypes.func,
  setAutoCheckIn: PropTypes.func,
  setAutoCheckInMinutes: PropTypes.func,
};
